var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"laya_title"},[_c('h1',{style:({ color: _vm.color || '#1f222a' })},[_vm._v(_vm._s(_vm.title))]),(_vm.$i18n.locale === 'zh')?_c('h2',{style:({ color: _vm.subColor || '#cbc9c9' })},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }